import { Outlet } from 'react-router'

import { Layout } from '@/components/layout'

const App = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
export default App
